



















































































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {FamilyManagement} from '@/modules/neovehicle/models/family';
import {Brand, VehicleType, vehicleTypes} from '@/modules/neovehicle/models';
import {FamilyFilter} from '@/modules/neovehicle/models/filters';
import debounce from 'lodash/debounce';
import {v4 as uuidv4} from 'uuid';

@Component
export default class extends Vue {
  @Prop({ type: Array, required: true })
  public data: FamilyManagement[];

  @Prop({ type: Boolean, required: true })
  public loading: boolean;

  @Prop({type: Array})
  public brands: Brand[];

  @Prop({type: Array})
  public vehicleTypesSearch: VehicleType[];

  @Prop({ type: Object, required: true })
  public filter: FamilyFilter;

  @Prop({type: Boolean})
  public buttonDisabled: boolean;

  public pagination = {
    sortBy: 'name',
    descending: false,
  };

  public vehicleTypes = vehicleTypes;
  public checkboxAll: boolean = false;
  public uuidv4 = uuidv4;
  public checkboxSelected: FamilyManagement[] = [];

  public headers = [
    {text: '', value: 'checkbox', sortable: false, width: 10, checkbox: true},
    {text: 'Código', value: 'idFamily', sortable: true, width: 100},
    {text: 'Tipo de Veículo', value: 'idVehicleTypes', width: 150},
    {text: 'Bandeira', value: 'brandName'},
    {text: 'Família', value: 'familyName'},
    {text: 'Grupo/Família', value: 'familyGroupName'},
    {text: '', value: '', sortable: false, width: 50},
  ];

  @Watch('checkboxSelected')
  public watchCheckboxSelected() {
    this.$emit('select', this.checkboxSelected);
  }

  public resetSelect() {
    this.checkboxSelected = [];
    this.checkboxAll = false;
  }

  public handlePagination() {
    this.checkboxAll = false;
  }

  public changeSort(column: string) {
    if (this.pagination.sortBy === column) {
      this.pagination.descending = !this.pagination.descending;
    } else {
      this.pagination.sortBy = column;
      this.pagination.descending = false;
    }
  }

  public canRemove(item: FamilyManagement): boolean {
    return !(item.hasModelAssociated || item.hasFamilyVersionAssociated);
  }

  public get handleSearch() {
    return debounce(() => {
      this.$emit('search');
    }, 1000);
  }

  public handleRemove(family: FamilyManagement) {
    this.$emit('remove', family);
  }

  public handleEdit(family: FamilyManagement) {
    this.$emit('edit', family);
  }

  public handleCheck(checked: boolean) {
    this.$nextTick(() => {
      [...document.querySelectorAll('input[data-id]')]
        .map((el: any) => Number(el.dataset.id))
        .forEach((id: number) => {
          if (checked) {
            const families = this.data.filter((m: FamilyManagement) => m.idFamily === id);

            if (families.length) {
              this.checkboxSelected.push(families[0]);
            }
          } else {
            this.checkboxSelected = this.checkboxSelected.filter((m: FamilyManagement) => m.idFamily !== id);
          }
        });
    });
  }

  public handleSelectMove() {
    this.$emit('click-select-move');
  }

  public handleCreateFamily() {
    this.$emit('create');
  }
}
